import { DragOverlay, useDraggable } from "@dnd-kit/core";
import { useRef, useState } from "react";

const KanbanItem = ({ id, children, data, disabled = false, onClick }) => {
  const [dragging, setDragging] = useState(false);
  const timerRef = useRef(null);
  const startPos = useRef({ x: 0, y: 0 });

  const { attributes, listeners, setNodeRef, active } = useDraggable({
    id: id,
    data: data,
    disabled,
  });

  const handleMouseDown = (e) => {
    startPos.current = { x: e.clientX, y: e.clientY };
    setDragging(false);

    timerRef.current = setTimeout(() => {
      setDragging(true);
    }, 150);
  };

  const handleMouseUp = (e) => {
    clearTimeout(timerRef.current);

    const dx = Math.abs(e.clientX - startPos.current.x);
    const dy = Math.abs(e.clientY - startPos.current.y);
    const moved = dx + dy > 5;

    if (!moved && !dragging && !disabled) {
      onClick?.();
    }

    setDragging(false);
  };

  return (
    <div style={{ position: "relative" }}>
      <div
        ref={setNodeRef}
        {...attributes}
        {...listeners}
        onMouseDown={handleMouseDown}
        onMouseUp={handleMouseUp}
        style={{
          opacity: active ? (active.id === id ? 1 : 0.5) : 1,
          borderRadius: "8px",
          position: "relative",
          cursor: disabled ? "default" : !dragging ? "pointer" : "grab",
          border: "1px solid #D2D5DC",
        }}
      >
        {active?.id === id && (
          <DragOverlay zIndex={1000}>
            <div
              style={{
                borderRadius: "8px",
                boxShadow: "rgba(149,157,165,0.2) 0px 8px 24px",
                cursor: "grabbing",
              }}
            >
              {children}
            </div>
          </DragOverlay>
        )}
        {children}
      </div>
    </div>
  );
};

export default KanbanItem;
